export class MarkAsDirty {
    static readonly type = '[Editor.Background] Mark as Dirty';
}
